// extracted by mini-css-extract-plugin
module.exports =  {"container":"_9330de7794--container--xpx3k","wrapper":"_9330de7794--wrapper--_YwQQ","title":"_9330de7794--title--rBOB_"};